// Central SEO/business constants.
export const SITE_URL = 'https://saniq.ai';
export const SITE_NAME = 'SaniQ';
export const DEFAULT_TITLE = 'SaniQ | World’s First Smart Disinfectant Doormat';
export const DEFAULT_DESCRIPTION =
  'SaniQ is the world’s first intelligent disinfectant door mat, removing 99.9% of germs, bacteria, and viruses from shoe soles in 2-3 seconds. Launching in Australia, 2027.';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/images/mat-top-cutout-cropped.png`;

export const CONTACT_EMAIL = 'info@saniq.ai';

// Legal entity name and ABN/ACN are still unconfirmed. Left blank rather than
// a visible placeholder, so Privacy.jsx/Terms.jsx fall back to the SaniQ trading
// name and simply omit the ABN line until these are filled in.
export const LEGAL_ENTITY_NAME = '';
export const LEGAL_ABN = '';
export const LEGAL_ADDRESS = 'Sydney, Australia';
export const LEGAL_JURISDICTION = 'Australia';
